/** Per-resource staleTime values (ms). */

const MINUTE = 60_000;

export const staleTimes = {
  documents: MINUTE,
  cases: MINUTE,
  caseDetail: MINUTE,
  conversations: 30_000,
  conversationDetail: MINUTE,
  models: 10 * MINUTE,
  workflows: 10 * MINUTE,
  chatPrompts: 10 * MINUTE,
  draftTypes: 10 * MINUTE,
  countries: 10 * MINUTE,
  qararkStatus: MINUTE,
  documentDetail: MINUTE,
  documentText: 5 * MINUTE,
};

/** Signed URL stale window: refresh 5 min before expiry. */
export function documentFileUrlStaleTime(fileMeta) {
  if (!fileMeta?.expires_in) return staleTimes.documentDetail;
  const margin = 5 * MINUTE;
  return Math.max((fileMeta.expires_in * 1000) - margin, 30_000);
}
